export default [
  'hasCarWash', // автомойка
  'hasCarService', // автосервис
  'hasAquapark', // аквапарк
  'hasPharmacy', // аптека
  'hasClothesStudio', // ателье одежды
  'hasAtm', // банкомат
  'hasPool', // бассейн
  'hasBabySitting', // беби-ситинг
  'hasBowling', // боулинг
  'hasBuffet', // буфет
  'hasHotel', // гостиница
  'hasGameRoom', // игровая комната
  'hasSlotMachines', // игровые автоматы
  'hasRink', // каток
  'hasCafe', // кафе
  'hasCinema', // кинотеатр
  'hasMedicalCenter', // медицинский центр
  'hasMinimarket', // минимаркет
  'hasBankDepartment', // отделение банка
  'hasRestaurant', // ресторан
  'hasBeautyShop', // салон красоты
  'hasWarehouse', // складские помещения
  'hasCanteen', // столовая
  'hasSupermarket', // супермаркет
  'hasFitnessCentre', // фитнес-центр
  'hasStudio', // фотосалон
  'hasFoodCourt', // фуд-корт
  'hasCentralReception', // центральная рецепция
];
